/* global axios */
import ApiClient from '../ApiClient';

class AssistantKnowledgeBases extends ApiClient {
  constructor() {
    super('assistant/knowledge_bases', { accountScoped: true });
  }

  get({ page = 1, searchKey } = {}) {
    return axios.get(this.url, {
      params: { page, search_key: searchKey },
    });
  }

  create(data = {}) {
    return axios.post(this.url, { knowledge_base: data });
  }

  update(id, data = {}) {
    return axios.patch(`${this.url}/${id}`, { knowledge_base: data });
  }
}

export default new AssistantKnowledgeBases();
